const topics = [
  { label: '明星塌房', hot: true, count: '326万讨论' },
  { label: '综艺翻车', hot: true, count: '218万讨论' },
  { label: '网红互撕', hot: true, count: '189万讨论' },
  { label: '恋情曝光', hot: false, count: '156万讨论' },
  { label: '代言风波', hot: false, count: '132万讨论' },
  { label: '潜规则', hot: true, count: '298万讨论' },
  { label: '选秀内幕', hot: false, count: '107万讨论' },
  { label: '绯闻实锤', hot: false, count: '95万讨论' },
  { label: '片酬爆料', hot: false, count: '88万讨论' },
  { label: '综艺CP', hot: false, count: '73万讨论' },
];

export default function TopicsSection() {
  return (
    <section id="topics" className="py-14 md:py-20 bg-background-100">
      <div className="px-4 md:px-6 max-w-7xl mx-auto">
        <div className="text-center mb-10">
          <span className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full bg-accent-100 text-accent-700 text-xs font-bold mb-4">
            <i className="ri-fire-line"></i>
            热门话题
          </span>
          <h2 className="text-2xl md:text-3xl font-heading font-black text-foreground-950 mb-3">
            大家都在搜
          </h2>
          <p className="text-foreground-500 text-sm max-w-lg mx-auto">
            实时追踪全网吃瓜热点，点击话题看更多相关内容
          </p>
        </div>

        <div className="flex flex-wrap justify-center gap-3">
          {topics.map((t, i) => (
            <a
              key={i}
              href="#topics"
              className={`group inline-flex items-center gap-2 px-4 py-2.5 rounded-full font-bold text-sm transition-all duration-200 ${
                t.hot
                  ? 'bg-primary-100 text-primary-700 hover:bg-primary-200 hover:shadow-md'
                  : 'bg-background-200/70 text-foreground-600 hover:bg-background-300 hover:text-foreground-800'
              }`}
            >
              {t.hot && <i className="ri-fire-line text-accent-500 text-xs"></i>}
              <span>#{t.label}</span>
              <span className={`text-xs ${t.hot ? 'text-primary-500' : 'text-foreground-400'}`}>
                {t.count}
              </span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}